module.exports = __webpack_public_path__ + "img/bg1.4d9ca8ac.jpg";